// extracted by mini-css-extract-plugin
module.exports = {"ingredientsContainer":"ingredients-list-container_ingredientsContainer__2W5TB"};